module.exports = __webpack_public_path__ + "img/Flaticon2.02b16c81.svg";